<ng-container
  *ngIf="{
    reqPComparator: reqPComparator$ | async,
  } as content"
>
  <div class="simple-card">
    <page-title></page-title>
  </div>

  <div #container class="product-comparator-container simple-card m-t-20">
    <div #tableContainer class="scroll-container {{ getClassContainer(content.reqPComparator?.pComparator?.products?.length || 0) }}">
      <div class="scroll-section" #section1 (scroll)="syncScroll(section1, section2, section3)">
        <div class="row-x product-cards-big">
          <div class="column-x fixed-column">{{ 'productComparator.product' | cxTranslate }}</div>

          <div class="column-x" *ngFor="let product of content.reqPComparator?.pComparator?.products">
            <product-comparator-item [product]="product"></product-comparator-item>
          </div>
        </div>
      </div>

      <div class="fixed-row" #stickyElement>
        <div class="scroll-section" #section2 (scroll)="syncScroll(section2, section1, section3)">
          <div class="row-x product-cards-mini">
            <div class="column-x fixed-column">{{ 'productComparator.product' | cxTranslate }}</div>

            <div class="column-x" *ngFor="let product of content.reqPComparator?.pComparator?.products">
              {{ product.name }}
            </div>
          </div>
        </div>

        <div class="container-config">
          <div class="form-group m-0">
            <label for="" class="m-0">
              <div class="container-view-type">
                <div class="form-check m-b-0" *ngFor="let type of viewOptions">
                  <input
                    id="radio-{{ type.code }}"
                    class="form-check-input"
                    role="radio"
                    type="radio"
                    aria-checked="true"
                    [value]="type.code"
                    name="viewType"
                    [checked]="type.code === viewType.code"
                    (click)="onlyKeySpecsView(type)"
                  />

                  <label class="form-check-label form-radio-label" for="radio-{{ type.code }}">
                    {{ type.label }}
                  </label>
                </div>
              </div>
            </label>
          </div>

          <div class="form-group m-0">
            <div class="form-check m-0">
              <label class="m-0">
                <input #checkbox type="checkbox" name="differences" formControlName="differences" (click)="highlightView(checkbox)" />
                <span class="form-check-label">{{ 'productComparator.highlightDifferences' | cxTranslate }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="scroll-section" #section3 (scroll)="syncScroll(section3, section1, section2)">
        <ng-container *ngFor="let section of content.reqPComparator?.pComparator?.sections; let i = index">
          @if (i !== 0) {
            <div class="row-space"></div>
          }

          <div class="row-x section-name">
            <div class="column-x fixed-column">
              <div class="section-title">
                <button #button type="button" class="active" (click)="toggleRow(button, section.code!)">
                  <span class="material-symbols-outlined icon"> keyboard_arrow_down </span>

                  <span class="title">
                    {{ section.name }}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div
            *ngFor="let row of section.rows"
            class="row-x js-commom-row commom-row js-row-{{ section.code }}"
            [ngClass]="{ 'key-specs': row.keySpec }"
          >
            <div class="column-x fixed-column">
              {{ row.title }}
            </div>

            <div
              class="column-x"
              *ngFor="let td of row.values"
              [ngClass]="{ 'is-different': row.values && td.value !== row.values[0].value }"
            >
              <span class="title-responsive m-r-4"> {{ row.title }}: </span>

              {{ td.value }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>